export enum PaymentTypes {
    DISCOUNT = "DISCOUNT_DARF",
    DONATION = "DONATION",
    FAM_ANUAL_MEMBERSHIP = "FAM_ANUAL_MEMBERSHIP",
    PCS_ANUAL_MEMBERSHIP = "PCS_ANUAL_MEMBERSHIP"
}